const font_weights = {
  LIGHT: 300,
  REGULAR: 400,
  SEMI_BOLD: 600,
};

export default {
  ...font_weights,

  H1_HERO_MOBILE: 64,
  H1_HERO_DESKTOP: 60,
  H1_HERO_DESKTOP_HD: 66,
  H1_HERO_FONT_WEIGHT: font_weights.SEMI_BOLD,

  H1_MOBILE: 30,
  H1_DESKTOP: 36,
  H1_DESKTOP_HD: 40,
  H1_FONT_WEIGHT: font_weights.SEMI_BOLD,
  H1_DESKTOP_MB: 40,
  H1_TABLET_MB: 36,
  H1_DESKTOP_HD_MB: 44,

  H2_MOBILE: 27,
  H2_DESKTOP: 30,
  H2_DESKTOP_HD: 33,
  H2_FONT_WEIGHT: font_weights.LIGHT,

  H3_MOBILE: 24,
  H3_DESKTOP: 27,
  H3_DESKTOP_HD: 29,
  H3_FONT_WEIGHT: font_weights.LIGHT,
  H3_DESKTOP_MB: 60,
  H3_TABLET_MB: 54,
  H3_DESKTOP_HD_MB: 66,

  H4_MOBILE: 21,
  H4_DESKTOP: 23,
  H4_DESKTOP_HD: 26,
  H4_FONT_WEIGHT: font_weights.LIGHT,

  H5_MOBILE: 18,
  H5_DESKTOP: 20,
  H5_DESKTOP_HD: 22,
  H5_FONT_WEIGHT: font_weights.REGULAR,
  H5_DESKTOP_MB: 30,
  H5_TABLET_MB: 27,
  H5_DESKTOP_HD_MB: 33,

  P_MOBILE: 18,
  P_DESKTOP: 20,
  P_DESKTOP_HD: 22,
  P_DESKTOP_HD_SMALL: 16,
  P_FONT_WEIGHT: font_weights.REGULAR,

  SMALL_MOBILE: 15,
  SMALL_DESKTOP: 15,
  SMALL_DESKTOP_HD: 17,
  SMALL_FONT_WEIGHT: font_weights.REGULAR,

  HEADER_LINE_HEIGHT: '1.32',
  LIST_ITEM_LINE_HEIGHT: '1.6',
  PARAGRAPH_LINE_HEIGHT: '1.75',
  PARAGRAPH_LINE_HEIGHT_SMALL: '1.9',
};



// WEBPACK FOOTER //
// ./src/identity/typeScale.js